import styled, { css } from 'styled-components';

interface ButtonProps {
  loading?: boolean;
}

export const Container = styled.button<ButtonProps>`
  width: 100%;
  height: 60px;
  color: var(--white);
  background: var(--primary);
  border: 0;
  border-radius: 20px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  padding: 0 20px;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  outline: none;

  ${props =>
    props.loading &&
    css`
      opacity: 0.8;
      cursor: progress;
    `}
  transition: box-shadow 0.2s ease-in-out;

  :focus {
    box-shadow: 0 0 0px 3px rgba(0, 0, 0, 0.2);
  }

  display: flex;
  justify-content: center;
  align-items: center;

  > svg:last-child {
    margin-left: 8px;
  }

  > svg:first-child {
    margin-right: 8px;
  }
`;
